import * as React from "react";
const SvgVercel = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 128, height: 128, viewBox: "0 0 128 128", ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  fillRule: "nonzero",
  fill: "#000",
  fillOpacity: 1
}, d: "M63.984 17.184 127.964 128H0Zm0 0" }));
export default SvgVercel;
